import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const LineGraph16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.3785 6.06033L14.6102 2.93594L13.3896 2.06409L11.2921 5.00066L9.78164 4.09439C9.22281 3.75909 8.50014 3.90939 8.12135 4.4397L6.2921 7.00066L4.78164 6.09439C4.22281 5.75909 3.50014 5.90939 3.12135 6.4397L0.889648 9.56409L2.11025 10.4359L4.2078 7.49937L5.71826 8.40565C6.27709 8.74094 6.99975 8.59064 7.37855 8.06033L9.2078 5.49937L10.7183 6.40565C11.2771 6.74094 11.9998 6.59064 12.3785 6.06033Z'
      fill='currentColor'
    />
    <path d='M15 12.25H1V13.75H15V12.25Z' fill='currentColor' />
  </Svg>
);

LineGraph16.displayName = 'LineGraph16';
export default LineGraph16;
